import { initializeApp } from 'firebase/app'
import { getAuth } from 'firebase/auth'
import { getFirestore } from 'firebase/firestore'
import { getStorage } from 'firebase/storage'
import { getAnalytics } from 'firebase/analytics'

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
// Get values from environment variables or use defaults if already configured
const firebaseConfig = {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyDfX1TbkdQ6scS_eO0FXUd_fvltX8X_y6E",
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "lpaandriod.firebaseapp.com",
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "lpaandriod",
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "lpaandriod.firebasestorage.app",
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "446125335946",
    appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:446125335946:web:ad0ee2744bc998f74f1473",
    measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || "G-VFSSW02YE5"
}

// Initialize Firebase
const app = initializeApp(firebaseConfig)

// Initialize Firebase services
export const auth = getAuth(app)
export const db = getFirestore(app)
export const storage = getStorage(app)

// Initialize Analytics only in browser environment
export const analytics = typeof window !== 'undefined' ? getAnalytics(app) : null

export default app

